
export default {
  weather(lat, lon, lang) {
    // TODO: Перенести сюда апишку погоды
  },
  autoCompleteSearch(query = '', lang = 'en') {

    
  }
}
